module.exports = __webpack_public_path__ + "img/pp7.66cba313.png";